import datapoints from '../../datapoints';
import { favoritesStore, isSearchInFavorites, updateFavoritesUserOption, } from 'owa-favorites';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { action } from 'satcheljs/lib/legacy';
/**
 * Add a favorite search to the favorite store
 */
export default action('AddFavoriteSearch', datapoints.AddFavoriteSearch)(function addFavoriteSearch(searchQuery, actionSource) {
    // Check if search query is already in favorites
    if (isSearchInFavorites(searchQuery)) {
        throw new Error('Cannot add duplicate search query to favorites.');
    }
    // Add favorite to favorites store
    favoritesStore.orderedFavoritesNodeIds.push(searchQuery);
    favoritesStore.favoriteSearches.set(searchQuery, {
        id: searchQuery,
        type: 3 /* Search */,
        treeType: 'favorites',
        dropViewState: createDropViewState(),
    });
    // Update user options service which is used by OWA
    updateFavoritesUserOption();
});
//# sourceMappingURL=addFavoriteSearch.js.map